import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import PromiseSection from './components/PromiseSection';
import VideoSection from './components/VideoSection';
import SolutionSection from './components/SolutionSection';
import HowItWorksSection from './components/HowItWorksSection';
import DetailsSection from './components/DetailsSection';
import LifestyleSection from './components/LifestyleSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import SpecsSection from './components/SpecsSection';
import ReviewsSection from './components/ReviewsSection';
import OfferSection from './components/OfferSection';
import TrustSection from './components/TrustSection';
import WhatsIncludedSection from './components/WhatsIncludedSection';
import GuaranteeSection from './components/GuaranteeSection';
import FAQSection from './components/FAQSection';
import UrgencyOfferSection from './components/UrgencyOfferSection';
import FinalClosingSection from './components/FinalClosingSection';
import FinalCTASection from './components/FinalCTASection';
import Navigation from './components/Navigation';

export default function HomePage() {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-in-section');
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.8;
        if (isVisible) {
          el.classList.add('is-visible');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-black text-white">
      <Navigation />
      <HeroSection />
      <ProblemSection />
      <PromiseSection />
      <VideoSection />
      <SolutionSection />
      <HowItWorksSection />
      <DetailsSection />
      <LifestyleSection />
      <BeforeAfterSection />
      <SpecsSection />
      <ReviewsSection />
      <OfferSection />
      <TrustSection />
      <WhatsIncludedSection />
      <GuaranteeSection />
      <FAQSection />
      <UrgencyOfferSection />
      <FinalClosingSection />
      <FinalCTASection />
    </div>
  );
}